<template>
  <section id="escalate-enquiry-form">
    <p v-if="this.$router.currentRoute.path.includes('/collection-enquiry/cancel-collection-ba/five-or-less') || this.$router.currentRoute.path.includes('/collection-enquiry/cancel-collection-ba/more-than-five')">OK, please provide all parcel IDs that need to be cancelled, and then click "Submit Enquiry"</p>
    <p v-else>OK, if you would like to add any additional information to support your enquiry you can do so below, or otherwise just click to submit your enquiry</p>
    <EmailFormInput />
    <SubmitButton btnText="Submit Enquiry" />
  </section>
</template>

<script>
import EmailFormInput from '../components/EmailFormInput'
import SubmitButton from '../components/SubmitButton'

export default {
  components: {
    EmailFormInput,
    SubmitButton
  }
}
</script>


// WEBPACK FOOTER //
// src/components/EscalateEnquiryForm.vue